import { renderMathHtml } from '@naia-app/shared';
import 'katex/dist/katex.min.css';

/*
 * Point d'entree unique du LaTeX cote web : chat, NodeViews de l'editeur et
 * apercu live passent tous par ici.
 *
 * Le rendu n'est PAS reimplemente. Il est delegue a renderMathHtml de
 * packages/shared — la fonction qu'appelle aussi l'export PDF. L'ecran et le
 * papier partagent donc une unique configuration KaTeX (mhchem enregistre,
 * throwOnError actif, meme repli visible, meme mention portee par le balisage)
 * au lieu d'en tenir chacun une copie qui derive.
 *
 * Cette indirection n'est pas un alias : elle porte l'import de la feuille de
 * style KaTeX, que packages/shared ne peut pas faire puisqu'il rend aussi
 * cote serveur. C'est aussi le seul fichier d'apps/web autorise a importer
 * KaTeX, invariant tenu par un test dans latex.test.tsx. Rendre une formule
 * ailleurs qu'ici recree la divergence ecran / papier.
 */
export function renderLatexToHtml(tex: string, displayMode = false): string {
  return renderMathHtml(tex, displayMode);
}
